import { Component, OnInit, Input, SimpleChanges, ViewChild, ElementRef, forwardRef } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { ReactiveFormsModule, ControlContainer, FormGroupDirective, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { MarvSpeechToTextComponent } from '@marv/components'; 
import { MarvValidatorsService } from '@marv/services'; 

@Component({
    selector: 'marv-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    imports: [IonIcon, ReactiveFormsModule, forwardRef(() => MarvSpeechToTextComponent)],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ]
})
export class MarvInputComponent implements OnInit {

    @Input({alias : 'type', required : true}) typeInput: string = 'text';  
    @Input({alias : 'label', required : false}) labelInput: string = '';
    @Input({alias : 'fixedLabel', required : false}) fixedLabel: boolean = false;
    @Input({alias : 'icon', required : false}) iconInput: string = '';
    @Input({alias : 'formName', required : true}) formName: string|number = '';
    @Input({alias : 'errorText', required : false}) errorText: string = this.translateService.instant('MSG_ERROR_FIELD_MANDATORY');
    @Input({alias : 'disabled', required : false}) disabled: boolean = false;
    @Input({alias : 'autocomplete', required : false}) autocomplete: boolean = false;
    @Input({alias : 'showBtnClearInput', required : false}) showBtnClearInput: boolean = false;
    @Input({alias : 'noMargin', required : false}) noMargin: boolean = false;
    @Input({alias : 'withSpeechToText', required : false}) withSpeechToText: boolean = false;
    @Input({alias : 'textAlign', required : false}) textAlign: 'left'|'center'|'right' = 'left';
    @Input({alias : 'min', required : false}) min: number;
    @Input({alias : 'max', required : false}) max: number;

    @ViewChild('marvInput') marvInput: ElementRef;
    @ViewChild('marvSpeechToText') marvSpeechToText: MarvSpeechToTextComponent;

    originalTypeInput: string;
    showPassword: boolean = false;
    isRequired: boolean = false;
    
    updateStatusChange: Subscription;
    updateValueChange: Subscription;

    constructor(
        public translateService: TranslateService,
        public formGroupDirective: FormGroupDirective
    ) {}

    ngOnInit() {
        this.originalTypeInput = this.typeInput;
        this.isRequired = this.formGroupDirective.form.controls[this.formName].hasValidator(Validators.required); 
        this.updateStatusChange = this.formGroupDirective.form.controls[this.formName].statusChanges.subscribe((s) => {
            this.isRequired = this.formGroupDirective.form.controls[this.formName].hasValidator(Validators.required);
        });        
        this.updateValueChange = this.formGroupDirective.form.controls[this.formName].valueChanges.subscribe((newValue) => {
            if(newValue !== ''){
                if(typeof this.min === 'number' && newValue < this.min){
                    this.formGroupDirective.form.controls[this.formName].setValue(this.min);
                }
                else if(typeof this.max === 'number' && newValue > this.max){
                    this.formGroupDirective.form.controls[this.formName].setValue(this.max);
                }
            }
        });        
    }
    
    async ngOnChanges(changes: SimpleChanges) {                
        if(changes['disabled'] && changes['disabled'].currentValue !== null){    
            if(this.disabled === true){
                this.formGroupDirective.form.controls[this.formName].disable({emitEvent: false});
            }
            else{
                this.formGroupDirective.form.controls[this.formName].enable({emitEvent: false});
            }
        }
    }
    
    ngOnDestroy() {           
        if(this.updateStatusChange){
            this.updateStatusChange.unsubscribe();
        }
        if(this.updateValueChange){
            this.updateValueChange.unsubscribe();
        }
    }
    
    focusInput(){
        this.marvInput.nativeElement.focus();
    }
    
    togglePassword(){
        if(this.originalTypeInput === 'password'){
            this.showPassword = !this.showPassword;
            this.typeInput = (this.showPassword ? 'text' : 'password');
        }
    }
    
    speechToText(){
        if(!this.disabled){
            this.marvSpeechToText.open();
        }
    }
    
    onDismissSpeechToText(text: string){
        if(text !== '' && this.formGroupDirective.form.controls[this.formName]){
            let value: any = text;
            if(this.typeInput === 'number'){     
                value = parseInt(text.replace(/[^\-0-9]/g,''));
                if(!MarvValidatorsService.isInteger(value)){
                    value = 0;
                }
            }
            this.formGroupDirective.form.controls[this.formName].setValue(value);
        }
    }
    
    clearInput(){
        if(!this.disabled){
            if(this.formGroupDirective.form.controls[this.formName]){
                let value: any = '';
                if(this.typeInput === 'number'){
                    value = 0;
                }
                this.formGroupDirective.form.controls[this.formName].setValue(value);
            }
        }
    }
}
